import {mapGetters, mapActions} from "ui.vue3.vuex";
import {itemsStore} from "../stores/items";

export const MethodologicalSlider = {
    data(): object {
        return {
            itemList: []
        }
    },
    props: {
        title: '',
        typeItem: '',
    },
    computed: {
        ...mapGetters('itemsStore', ['newItems', 'popularItems']),
    },
    methods: {
        ...mapActions('itemsStore', ['getDetailInfo']),
        getClassItem(id) {
            let classColor = '';
            switch (id) {
                case 'Кванториумы':
                    // Кванториумы
                    classColor = 'pink';
                    break;
                case 'IT-кубы':
                    // IT-кубы
                    classColor = 'green';
                    break;
                case 'Точки роста и школьные лаборатории':
                    // Точки роста и школьные лаборатории
                    classColor = 'turquoise';
                    break;
                case 'Психолого-педагогические классы':
                    // Психолого-педагогические классы
                    classColor = 'purple';
                    break;
                case 'Воспитательные практики':
                    // Воспитательные практики
                    classColor = 'mark';
                    break;
                case 'Диалог с родителями':
                    // Диалог с родителями
                    classColor = 'green-lt';
                    break;
                case 'Образовательный контент по предметам':
                    // Образовательный контент по предметам
                    classColor = 'mint';
                    break;
                case 'Дополнительное образование детей':
                    // Дополнительное образование детей
                    classColor = 'green';
                    break;
                case 'Справочник научно-методических разработок':
                    // Справочник научно-методических разработок
                    classColor = 'turquoise';
                    break;
            }

            return classColor;
        },
        getStyle(url) {
            return `--img-url: url(${url})`;
        },
        getInfo(id) {
            this.getDetailInfo(id)
        },
        getClassSlider(id) {
            if(id === 1) {
                return 'js-methodological-carousel-popular'
            } else {
                return 'js-methodological-carousel'
            }
        },
        getSubjects(subject) {
            let tmp =[];
            subject.forEach(function (item) {
                tmp.push(item.label);
            })
            return tmp.join(', ');
        }
    },
    updated(){
        this.$nextTick(function () {
            window.methodolSwiper.update();
            window.methodolSwiperPopular.update();
        })
    },
    // popular
    // newi
    template: `
    <div class="methodological-sliders__item js-methodological-slider">
        <div class="methodological-sliders__subtitle">{{ title }}</div>
        <div class="swiper-container" :class="getClassSlider(typeItem)">
          <div class="swiper-wrapper">
            <div v-if="(typeItem == '1')" class="swiper-slide" v-for="item in popularItems">
                <a href="#popup-methodological-item" class="methodological-item js-popup-btn-target" @click="getInfo(item.id)">
                  <div class="methodological-item__content">
                    <div class="methodological-item__sections">{{ getSubjects(item.education_subjects) }}</div>
                    <div class="methodological-item__tags">
                      <div class="methodological-item__tag" :data-rubric-id="rubric.id" :class="getClassItem(rubric.label)" v-for="rubric in item.rubrics" :key="rubric.id">{{ rubric.label }}</div>
                    </div>
                    <div class="methodological-item__title">{{ item.title }}</div>
                <div class="methodological-item__excerpt"><span>{{ item.type.label }}</span> </div>
                    <div class="methodological-item__edu" :style="getStyle(item.owner_team.logo_url)" :data-url="item.owner_team.logo_url">{{ item.owner_team.name }}</div>
                  </div>
                  <div class="methodological-item__more">{{ $Bitrix.Loc.getMessage('TITLE_ITEMS_LIST_BTN_READ_MORE_TEXT') }}</div>
                </a>
            </div>
            <div v-if="(typeItem == '2')" class="swiper-slide" v-for="item in newItems">
              <a href="#popup-methodological-item" class="methodological-item js-popup-btn-target" @click="getInfo(item.id)">
                  <div class="methodological-item__content">
                    <div class="methodological-item__sections">{{ getSubjects(item.education_subjects) }}</div>
                    <div class="methodological-item__tags">
                      <div class="methodological-item__tag" :data-rubric-id="rubric.id" :class="getClassItem(rubric.label)" v-for="rubric in item.rubrics" :key="rubric.id">{{ rubric.label }}</div>
                    </div>
                    <div class="methodological-item__title">{{ item.title }}</div>
                <div class="methodological-item__excerpt"><span>{{ item.type.label }}</span> </div>
                    <div class="methodological-item__edu" :style="getStyle(item.owner_team.logo_url)" :data-url="item.owner_team.logo_url">{{ item.owner_team.name }}</div>
                  </div>
                  <div class="methodological-item__more">{{ $Bitrix.Loc.getMessage('TITLE_ITEMS_LIST_BTN_READ_MORE_TEXT') }}</div>
                </a>
            </div>            
          </div>
        </div>
        <div class="methodological-sliders__pagination js-methodological-slider-pagination"></div>
      </div>
  `
}